import Matter from "matter-js";
import { MainProduct } from "../../types";
import { getMainProductVariantById } from "..";

export const updateColor = (engine: Matter.Engine, mainProduct: MainProduct, activeMainProductVariantId: string) => {
  const mainProductVariantTextures = 
    getMainProductVariantById(mainProduct, activeMainProductVariantId)
    .textureUrls
  
  if (!mainProductVariantTextures.length) {
    return
  }

  const allChains = Matter.Composite
    .allBodies(engine.world)
    .filter(body => body.label.startsWith("chain/"));

  allChains.forEach(body => {
    const spriteIndex = Number(body.label.split("/")[1])
    const textureIndex = spriteIndex < mainProductVariantTextures.length
      ? spriteIndex
      : spriteIndex % mainProductVariantTextures.length

    body.render.sprite!.texture = mainProductVariantTextures[textureIndex] ?? body.render.sprite!.texture
  })
}